import { firestore } from "fb";
import { query, limit, collection, where, orderBy } from "firebase/firestore";
import { useFirestoreQuery } from "@react-query-firebase/firestore";

export const useArticlesQuery = (symbol: string) => {
  const ref = query(
    collection(firestore, 'articles'),
    limit(20),
    where('symbol', '==', symbol),
    orderBy('publishedAt', 'desc'),
  );

  return useFirestoreQuery(['articles', symbol], ref);
}
